import React from 'react'
import { useParams } from 'react-router-dom'
import ProductData from '../page/ProductData'
function Details() {
  let {did}=useParams()
  let dis=ProductData.find((a)=>a.id==did)
  return (
    <div className='container py-5 my-5'>
      <h1>details {did}</h1>
      <div className='row'>
        <div className='col-lg-4 me-2'>
        <div className='border p-5'><img className='w-100 owl mx-1' src={dis.image}/></div>
      <div className='row mt-3'>
          <div className='col-lg-4'><img className='border' width={90}  src={dis.image}/></div>
          <div className='col-lg-4'><img className='border' width={90} src={dis.image}/></div>
          <div className='col-lg-4'> <img className='border' width={90} src={dis.image}/></div>
         </div>
        </div>
        <div className='col-lg-6 pt-4'>
        <h3>{dis.title}</h3>
        <div className='d-flex'>
          <span className='d-flex align-items-center fs-5 fw-semibold py-3'>
        <p className='text-body-tertiary  pe-3'>Rs.{dis.price}</p>
        <p className='text-decoration-line-through pe-3'>Rs.55.25</p>
        <p className='text-danger'>35% Off</p>
        </span>
        </div>
        <div className='d-flex align-items-center pt-3'>
        <h4 className='text-secondary pe-4'>Size</h4>
        <button type="button" class="btn btn-outline-dark border me-2">S</button>
        <button type="button" class="btn btn-outline-dark border me-2">M</button>
        <button type="button" class="btn btn-outline-dark border me-2">L</button>
        <button type="button" class="btn btn-outline-dark border">XL</button>
        </div>
        <div className='d-flex align-items-center pt-4'>
        <h4 className='pe-4'>Color</h4>
        <button type="button" class="btn btn-primary border me-2 rounded-circle p-2"></button>
        <button type="button" class="btn btn-danger border me-2 rounded-circle p-2"></button>
        <button type="button" class="btn btn-success border me-2 rounded-circle p-2"></button>
        <button type="button" class="btn btn-secondary border rounded-circle p-2"></button>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Details
